import { motion } from "framer-motion";
import Eyebrow from "../shared/Eyebrow";
import RevealText from "../shared/RevealText";
import WhatsAppButton from "../shared/WhatsAppButton";
import { PROCESS_STEPS } from "../../data/audiences";
import { viewport } from "../../lib/motion";

export default function Process() {
  return (
    <section
      className="bg-ink py-24 md:py-32 border-t border-charcoal/50"
      data-testid="process-section"
    >
      <div className="container-emilio">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <Eyebrow>How It Works</Eyebrow>
            <RevealText
              as="h2"
              text={"Four simple steps.\nNo guesswork."}
              className="mt-4 font-display font-extrabold text-white text-display"
            />
          </div>
          <div className="lg:col-span-5 lg:justify-self-end">
            <WhatsAppButton
              label="Start Your Booking on WhatsApp"
              testId="process-whatsapp"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-charcoal border border-charcoal">
          {PROCESS_STEPS.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={viewport}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="bg-ink p-8 md:p-10 relative overflow-hidden group"
            >
              <span className="absolute -bottom-4 -right-2 font-display font-extrabold text-[7rem] leading-none text-charcoal/80 select-none">
                {step.step}
              </span>
              <div className="relative">
                <div className="text-emerald text-xs font-mono">STEP {step.step}</div>
                <h3 className="mt-3 font-display font-bold text-white text-xl leading-tight">
                  {step.title}
                </h3>
                <p className="mt-3 text-mutedtext text-sm leading-relaxed">
                  {step.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
